import React from 'react';
import {MobileBox} from '~/common/FabricInvitation/EventCreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorContainer} from '~/common/FabricInvitation/EventCreateDesign/components/Container/Mobile/EditorContainer';
import {EditorIcons} from '~/common/FabricInvitation/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useEnvelope} from '~/common/FabricInvitation/EventCreateDesign/components/Envelope/actions/useEnvelope';
import {useLiners} from '~/common/FabricInvitation/EventCreateDesign/components/Envelope/actions/useLiner';
import {useStamp} from '~/common/FabricInvitation/EventCreateDesign/components/Stamp/actions/useStamp';
import {Stickers} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/components/Stickers/Stickers';
import {useEnvelopeContext} from '~/common/FabricInvitation/EventCreateDesign/contexts/EnvelopeContext';
import './EnvelopeEditorMobile.sass';

export const EnvelopeEditorMobile: React.FC = () => {
  const {handleFlipEnvelope} = useEnvelopeContext();
  const {envelopeIcons, onEnvelopeChange, selectedEnvelope} = useEnvelope();
  const {linerIcons, onLinerChange, selectedLiner} = useLiners();
  const {stampIcons, onStampChange, selectedStamp} = useStamp();

  return (
    <EditorContainer scrolls flipEnvelope={handleFlipEnvelope}>
      <EditorContainer.Tab title="Colors">
        <MobileBox>
          <EditorIcons
            icons={envelopeIcons}
            onClick={onEnvelopeChange}
            selectedIcon={selectedEnvelope?.icon}
            height={40}
            width={40}
            circle
          />
        </MobileBox>
      </EditorContainer.Tab>
      <EditorContainer.Tab title="Liner">
        <MobileBox>
          <EditorIcons
            icons={linerIcons}
            onClick={onLinerChange}
            selectedIcon={selectedLiner?.icon}
            height={40}
            width={40}
          />
        </MobileBox>
      </EditorContainer.Tab>
      <EditorContainer.Tab title="Stamps" showEnvelopeFront>
        <MobileBox>
          <EditorIcons
            icons={stampIcons}
            onClick={onStampChange}
            selectedIcon={selectedStamp?.image}
            height={40}
            width={50}
            className="editor-icons__stamp"
          />
        </MobileBox>
      </EditorContainer.Tab>
      <EditorContainer.Tab title="Stickers" showEnvelopeFront>
        <MobileBox>
          <Stickers flipEnvelope={handleFlipEnvelope} />
        </MobileBox>
      </EditorContainer.Tab>
    </EditorContainer>
  );
};
